document.addEventListener('DOMContentLoaded', () => {
    const fileInputs = document.querySelectorAll('.wpcf7-file');

    fileInputs.forEach((input) => {
        // Crea il pulsante custom e l'area per il nome file
        const label = document.createElement('span');
        label.className = 'custom-file-upload';
        label.textContent = 'Carica un file';

        const fileNameDisplay = document.createElement('span');
        fileNameDisplay.className = 'file-name';

        // Inserisci dopo l’input
        input.parentNode.insertBefore(label, input.nextSibling);
        input.parentNode.insertBefore(fileNameDisplay, label.nextSibling);

        // Clic sul bottone custom → apre il file picker
        label.addEventListener('click', () => input.click());

        // Mostra il nome del file scelto
        input.addEventListener('change', () => {
            const fileName = input.files.length ? input.files[0].name + ' ' + 'caricato' : '';
            const labelName = input.files.length ? 'File caricato. Clicca per cambiare file' : 'Carica un file';
            fileNameDisplay.textContent = fileName || '';
            label.textContent = labelName;
        });
    });
});
